import { createFileRoute, redirect } from "@tanstack/react-router";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/popup/")({
  loader: ({ params }) => {
    return redirect({
      to: "/consent-solutions/$csId/popup/my-templates",
      params: { csId: params.csId },
    });
  },
});

export { Route };
